// FUNÇÕES/MÓDULOS SITE
import HoverBackgroundGradient from './modules/Animation/hover_bg-gradient'
import ScrollSmooth from './modules/Animation/scrollLenis'
import AnimationElements  from './modules/Animation/enterElements'
import Footer from './modules/Layouts/footer'
import Header from './modules/Layouts/header'
import AnchorLinks from './modules/Utils/anchor_links'
import ImageEnter from './modules/Animation/imageEnter'
import ImagesHovers from './modules/Animation/imageHovers'
import removeEmptyImg from './modules/Utils/removeEmptyImg'
import bootstrapForms from './modules/Forms/bootstrapForms'
import { VirtualTourModal } from './components/virtualTourModal'


//aplica display: none em imagens sem src/sem cadastro
removeEmptyImg();
//forms
bootstrapForms();

// Animations
ScrollSmooth() // Lenis smooth scroll - must be initialized before other animations
AnimationElements()
HoverBackgroundGradient()
ImageEnter()
ImagesHovers()

// Layout
Footer()
Header()

// Utils
AnchorLinks()
setTimeout(() => {
    window.virtualTourModal = new VirtualTourModal();
}, 100);
